export default __webpack_public_path__ + "static/jussi-892233ade3322f3ed01bc0a43daea22f.webp";